import { OrderStatusType } from '@pu/models';

export const orderStatusTypes: OrderStatusType[] = ['new', 'confirmed', 'shipping', 'delivered', 'canceled', 'completed'];
